import type { ReactElement, SVGProps } from "react";

export function AnthropicMarkIcon(
  props: SVGProps<SVGSVGElement>
): ReactElement {
  return (
    <svg viewBox="0 0 24 24" fill="currentColor" {...props}>
      <path d="M17.308 3.147H14.05l5.855 17.706h3.258L17.308 3.147Zm-10.616 0L.837 20.853h3.34l1.2-3.744h6.072l1.2 3.744h3.34L10.134 3.147H6.692Zm-.528 11.1L8.413 7.59l2.249 6.657H6.164Z" />
    </svg>
  );
}
